module.exports = __webpack_public_path__ + "img/news-hero-2-449123c.jpg";